import { useState } from "react";

export type BlockFilterValue = "all" | "blocked" | "unblocked";
export type QuarantineFilterValue = "all" | "quarantine" | "not_quarantine";
/** Фильтр по флагу need_update_stock у маркетплейса */
export type NeedUpdateFilterValue = "all" | "need" | "no";
/** Свежесть последней отправки на выбранный МП */
export type SendAgeFilterValue =
  | "all"
  | "never"
  | "hour"
  | "day"
  | "older";
export type SendAgeMarketplace =
  | "wb"
  | "ozon"
  | "ya"
  | "sber"
  | "ali";

export const useFilter = () => {
  const [showCombo, setShowCombo] = useState(true);
  const [showSingle, setShowSingle] = useState(true);
  const [search, setSearch] = useState("");
  const [blockFilterWb, setBlockFilterWb] = useState<BlockFilterValue>("all");
  const [blockFilterOzon, setBlockFilterOzon] = useState<BlockFilterValue>("all");
  const [blockFilterYa, setBlockFilterYa] = useState<BlockFilterValue>("all");
  const [blockFilterSber, setBlockFilterSber] = useState<BlockFilterValue>("all");
  const [blockFilterAli, setBlockFilterAli] = useState<BlockFilterValue>("all");
  const [ozonQuarantineFilter, setOzonQuarantineFilter] =
    useState<QuarantineFilterValue>("all");
  const [needUpdateFilterWb, setNeedUpdateFilterWb] =
    useState<NeedUpdateFilterValue>("all");
  const [needUpdateFilterOzon, setNeedUpdateFilterOzon] =
    useState<NeedUpdateFilterValue>("all");
  const [needUpdateFilterYa, setNeedUpdateFilterYa] =
    useState<NeedUpdateFilterValue>("all");
  const [needUpdateFilterSber, setNeedUpdateFilterSber] =
    useState<NeedUpdateFilterValue>("all");
  const [needUpdateFilterAli, setNeedUpdateFilterAli] =
    useState<NeedUpdateFilterValue>("all");
  const [sendAgeMp, setSendAgeMp] = useState<SendAgeMarketplace>("wb");
  const [sendAgeFilter, setSendAgeFilter] =
    useState<SendAgeFilterValue>("all");

  return {
    showCombo,
    setShowCombo,
    showSingle,
    setShowSingle,
    search,
    setSearch,
    blockFilterWb,
    setBlockFilterWb,
    blockFilterOzon,
    setBlockFilterOzon,
    blockFilterYa,
    setBlockFilterYa,
    blockFilterSber,
    setBlockFilterSber,
    blockFilterAli,
    setBlockFilterAli,
    ozonQuarantineFilter,
    setOzonQuarantineFilter,
    needUpdateFilterWb,
    setNeedUpdateFilterWb,
    needUpdateFilterOzon,
    setNeedUpdateFilterOzon,
    needUpdateFilterYa,
    setNeedUpdateFilterYa,
    needUpdateFilterSber,
    setNeedUpdateFilterSber,
    needUpdateFilterAli,
    setNeedUpdateFilterAli,
    sendAgeMp,
    setSendAgeMp,
    sendAgeFilter,
    setSendAgeFilter,
  };
};
